const viewerState = {
  userView: {},
  users: [],
  blogs: [],
  portfolios: [],
  messages: [],
  pricings: [],
  orders:[]
};

export const viwerReducer = (state = viewerState, action) => {
  const { payload, type } = action;

  if (type === "VIEWER_GET_SUCCESS") {
    return {
      ...state,
      veiws: payload,
    };
  }
  if (type === "LENGTH_GET_SUCCESS") {
    return {
      ...state,
      users: payload.users,
      blogs: payload.blogs,
      portfolios: payload.portfolios,
      messages: payload.messages,
      pricings: payload.pricings,
      userView:payload.userView,
      orders:payload.orders

    };
  }
  return state;
};
